import React,{ChangeEvent,useState,useCallback,useEffect} from "react";


import MembNtfyMsgCtxtInqApi from "Apis/MembNtfyMsgCtxtInqApi";
import UseLangLstQuery from "Apis/LangTxtInqApi";
import MgpStore from "Stores/Store";
import ApiResultModal from "Components/ApiResultModal";
<meta charSet="EUC-KR" />
interface ChildComponentProps{
 msgSno: string,
 MsgDeleFunc:Function

} 
const MembNtfyMsgCtxtUi = ({msgSno,MsgDeleFunc}:ChildComponentProps) => {
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    const[msgCtgrCdState,setMsgCtgrCdState] =useState();
    const[msgTitlState,setMsgTitlState] =useState();
    const[msgCtxtState,setMsgCtxtState] =useState();
    const[ntfyRecvDtimeState,setNtfyRecvDtimeState] =useState();
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");

    const openResultModal = (message: string) => {
        setResultModalMessage(message);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
    };
    useEffect(()=>{
        MembNtfyMsgCtxtInqApi(msgSno).then((resp)=>{
            switch(resp.apiHdr.code){
                case "MEMB0000":
                    setMsgCtgrCdState(resp.apiBody.msgCtgrNm)
                    setMsgTitlState(resp.apiBody.msgTitl)
                    setNtfyRecvDtimeState(resp.apiBody.ntfyRecvDtime)
                    setMsgCtxtState(resp.apiBody.msgCtxt)
                    break;
                default:
                    openResultModal(`${resp.apiHdr.msg} `);
                break;
            }

        });
    },[MgpStore.getState().LangSetState.Lang]);
    return (
        <>
            <ApiResultModal
                open={resultModalOpen}
                message={resultModalMessage}
                onClose={closeResultModal}
                confirmText={langData && langData.COMM_MAIN_CHK_MAIN_BTN_00}
            />
            <div className="Container640">
                <div>
                    <div className="ntfyMdalCtxtHeader">
                        <h1>{msgTitlState}</h1>
                    </div>
                    <div className="ntfyMdalCtxtTitlWrap">
                        <p>{msgCtgrCdState}</p>
                        <p className="dtimeTxt">{ntfyRecvDtimeState}</p>
                    </div>
                </div>
                {msgCtxtState != null ?
                    <pre className="ntfyMdalCtxtInfoWrap"
                    dangerouslySetInnerHTML={{
                        __html: msgCtxtState,
                    }}>
                    </pre>
                    :
                    <>
                    <div className="ntfyMdalCtxtInfoWrap">
                    </div>
                    </>

                }
                
            </div>

        </>
    )
}

export default MembNtfyMsgCtxtUi;
